import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d078348"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-spinner" }

import BaseLoader from '@/components/base/BaseLoader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSpinner',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseLoader, {
      class: "base-loader",
      isFetching: true
    })
  ]))
}
}

})